import React, { useState, useEffect, useContext } from 'react'
import Stepper from './Stepper'
import SiteContext from '@/context/SiteContext'
import QuestionGetter from './QuestionGetter'
import Registro from '@/components/Trivia/Registro'
import Hero from '@/components/Trivia/Hero'
import Start from '@/components/Trivia/Start'
import Final from '@/components/Trivia/Final'
import Ended from '@/components/Trivia/Ended'

const Trivia = () => {
  const { setQuestionsLength, activeQuestion } = useContext(SiteContext)

  const data = QuestionGetter()
  const [started, setStarted] = useState(false)
  const [isLengthSetted, setLengthSetted] = useState(false)
  const [overQuestions, setOverQuestions] = useState(false)
  const [overRegister, setOverRegister] = useState(false)

  useEffect(() => {
    if (!isLengthSetted) {
      setQuestionsLength(data.length)
      setLengthSetted(true)
    }
  }, [data, isLengthSetted])

  const handleStart = () => {
    setStarted(true)
  }

  return (
    <div>
      {started ? (
        <div>
          {typeof data[activeQuestion] === 'undefined' ? (
            <>
              {overRegister ? (
                <Final />
              ) : (
                <Hero>
                  <Registro onRegistered={() => setOverRegister(true)} />
                </Hero>
              )}
            </>
          ) : (
            <Stepper data={data} activeQuestion={activeQuestion} />
          )}
        </div>
      ) : (
        <>
          <Hero>
            <Start onStarted={() => handleStart()} />
          </Hero>
        </>
      )}
    </div>
  )
}

export default Trivia
